module.exports = __webpack_public_path__ + "assets/connected_grey-89ca08.png";


//////////////////
// WEBPACK FOOTER
// ./Content/images/connected_grey.png
// module id = 365
// module chunks = 0